import DashboardLayout from './dashboard_layout';

export default DashboardLayout;
